const pattern = /^(?:(http|https):)?\/\/s3[.-](?:.*?).amazonaws.com/;

export default pattern;